import { render } from "./UserAchievements.vue?vue&type=template&id=00457bfc&scoped=true"
import script from "./UserAchievements.vue?vue&type=script&lang=js"
export * from "./UserAchievements.vue?vue&type=script&lang=js"

import "./UserAchievements.vue?vue&type=style&index=0&id=00457bfc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00457bfc"]])

export default __exports__